import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

import { stickyButtonContainerStyles } from "./sticky-button-container.css.js";

@customElement("wow-sticky-button-container")
export class WowStickyButtonContainer extends LitElement {
  static override styles = [stickyButtonContainerStyles];

  @property({ type: String, reflect: true })
  direction: "vertical" | "horizontal" = "vertical";

  @property({ type: Boolean, reflect: true, attribute: "desktop-static" })
  desktopStatic = false;

  override connectedCallback(): void {
    super.connectedCallback();
  }

  override render() {
    return html`
      <div
        class=${classMap({
          container: true,
          horizontal: this.direction === "horizontal",
        })}
      >
        <slot></slot>
      </div>
    `;
  }
}
